<template>
  <div class="match-info">
    <div v-if="!isServerSport">
      <div
        class="match-info-team flex flex-center-vertical"
        v-for="(team, index) in teams"
        :key="index">
        <span class="text-cut">
          {{ team.nameShort }}
        </span>
        <card-red
          :count="status.redCards[index]"
          v-if="status.redCards && status.redCards[index]"
        />
        <span class="filler" />
        <span
          class="period font-bold text-center"
          :class="{ 'color-important': iPeriod === 0, 'color-faded' : iPeriod !== 0 }"
          v-for="(period, iPeriod) in resultPeriod"
          :key="iPeriod">
          {{ period[index] }}
        </span>
      </div>
    </div>
    <div v-else>
      <div
        class="match-info-team flex flex-center-vertical"
        v-for="(team, index) in teams"
        :key="index">
        <span class="text-cut">
          {{ team.nameShort }}
        </span>
        <span class="filler" />
        <span
          class="period font-bold color-faded text-center flex-noshrink"
          :class="{ 'color-important': iPeriod === resultPeriod.length - 1 && !isTennis,
                    'color-normal': iPeriod === resultPeriod.length - 1 ||
                      (iPeriod !== resultPeriod.length - 1 ?
                        isHigher(resultPeriod[iPeriod][index === 0 ? 0 : 1],
                                 resultPeriod[iPeriod][index === 0 ? 1 : 0])
                        : false)
          }"
          v-for="(period, iPeriod) in resultPeriod"
          :key="iPeriod">
          {{ period[index] }}
        </span>
        <span
          class="period period-game font-bold color-important text-center flex-noshrink"
          v-if="gameScore">
          {{ gameScore[index] }}
        </span>
        <span class="icon-server-wrapper">
          <transition name="server-fade">
            <span
              class="icon-server middle"
              v-if="(index+1) === status.server"
              :key="index"
            />
          </transition>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { sport, comparison, resultPeriodMedium } from '@/services/mixins';
import CardRed from '@/components/common/card-red/CardRed.vue';

export default {
  name: 'MatchInfo',
  mixins: [sport, comparison, resultPeriodMedium],
  components: {
    CardRed,
  },
  props: {
    idSport: {
      required: true,
      type: Number,
    },
    teams: {
      required: true,
      type: Array,
    },
    status: {
      required: true,
      type: Object,
    },
  },
  computed: {
    gameScore() {
      return Object.prototype.hasOwnProperty.call(this.status, 'gameScore')
        ? this.status.gameScore.split(':') : undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-info {
  float: left;
  height: 20vh;
  width: 100%;
  padding: 3vh 25px;
  color: $color-text-primary;
  background-color: $match-color-back;
  border-top: 1px solid $row-color-border;
  border-bottom: 1px solid $row-color-border;
  font-size: 1.3125rem;

  /deep/ .card-wrapper {
    width: 1.510417vw;
    height: 4.35185vh;

    .card {
      width: 1.041667vw;
      height: 3.333vh;
      top: 0.5556vh;
    }

    .card-count {
      top: 0.5556vh;
      right: 0.15625vw;
      font-size: 0.6875rem;
    }
  }
}

.match-info-team {
  height: 7vh;
  line-height: 7vh;
}

.period {
  width: 3.125vw;
}

.period-game {
  width: 4.1667vw;
}

.icon-server-wrapper {
  position: relative;
  padding: 0 1.041667vw;

  .icon-server {
    width: $match-icon-server-width-large;
    height: $match-icon-server-width-large;
    border-radius: 50%;
    background-color: $color-important;
  }
}
</style>
